/* eslint-disable react/prop-types */
import Box from '@material-ui/core/Box'
import { MenuItem } from '@material-ui/core'
import Button from '@material-ui/core/Button'
import Grid from '@material-ui/core/Grid'
import IconButton from '@material-ui/core/IconButton'
import Popover from '@material-ui/core/Popover'
import TextField from '@material-ui/core/TextField'
import Tooltip from '@material-ui/core/Tooltip'
import FilterListIcon from '@material-ui/icons/FilterList'
import SearchIcon from '@material-ui/icons/Search'
import PopupState, { bindPopover, bindTrigger } from 'material-ui-popup-state'
import React, { useCallback, useState } from 'react'
import { KeyboardDatePicker } from '@material-ui/pickers'
import { ValidatorForm } from 'react-material-ui-form-validator'
import { useDispatch, useSelector } from 'react-redux'
import { endOfDay, format, startOfDay } from 'date-fns'

import BadgeGlobal from '../../components/Badge'
import { fetchSchedulesRelatoryInit } from '../SchedulesRelatoryActions'
import SelectField from '../../components/SelectField'

export default function Filter(props) {
  const items = useSelector(state => state.schedules_relatory.items)
  const equips = useSelector(state => state.schedules_relatory.equips)
  const servicesTypes = useSelector(
    state => state.schedules_relatory.servicesTypes
  )
  const companies = useSelector(state => state.schedules_relatory.companies)

  const dispatch = useDispatch()
  const { classes } = props
  const [form, setForm] = useState({
    id: '',
    name: '',
    equip: '',
    date_start: new Date(),
    date_end: new Date(),
    service_type: '',
    company: '',
  })

  const onSubmit = e => {
    e.preventDefault()
    const dateStart = form.date_start
      ? format(startOfDay(new Date(form.date_start)), 'yyyy-MM-dd HH:mm:ss')
      : null
    const dateEnd = form.date_end
      ? format(endOfDay(new Date(form.date_end)), 'yyyy-MM-dd HH:mm:ss')
      : null
    const data = {
      ...form,
      service_type: form.service_type?.id,
      date_start: dateStart,
      date_end: dateEnd,
    }
    dispatch(fetchSchedulesRelatoryInit(null, data, null))
  }

  const updateField = useCallback(
    (name, value) => {
      setForm({ ...form, [name]: value })
    },
    [form]
  )

  return (
    <Tooltip title="Filter list">
      <PopupState variant="popover" popupId="demo-popup-popover">
        {popupState => (
          <div>
            <IconButton aria-label="filter list" {...bindTrigger(popupState)}>
              <BadgeGlobal form={form} items={items}>
                <FilterListIcon />
              </BadgeGlobal>
            </IconButton>
            <Popover
              {...bindPopover(popupState)}
              anchorOrigin={{
                vertical: 'bottom',
                horizontal: 'center',
              }}
              transformOrigin={{
                vertical: 'top',
                horizontal: 'center',
              }}
            >
              <Box p={2} className={classes.popover}>
                <div className={classes.root}>
                  <ValidatorForm className={classes.form} onSubmit={onSubmit}>
                    <Grid
                      container
                      className={classes.gridContainer}
                      spacing={1}
                      justify="center"
                      alignItems="center"
                    >
                      <Grid item xs={6}>
                        <TextField
                          onChange={e =>
                            setForm({ ...form, id: e.target.value })
                          }
                          label="Numero da OS"
                          margin="dense"
                          className={classes.inputFilter}
                          variant="outlined"
                          fullWidth
                          value={form.id}
                        />
                      </Grid>

                      <Grid item xs={6}>
                        <TextField
                          onChange={e =>
                            setForm({ ...form, name: e.target.value })
                          }
                          label="Nome do Cliente"
                          margin="dense"
                          className={classes.inputFilter}
                          variant="outlined"
                          fullWidth
                          value={form.name}
                        />
                      </Grid>

                      <Grid item xs={6}>
                        <TextField
                          onChange={e =>
                            setForm({ ...form, equip: e.target.value })
                          }
                          select
                          label="Equipe"
                          className={classes.inputFilter}
                          fullWidth
                          margin="dense"
                          variant="outlined"
                          value={form.equip}
                        >
                          <MenuItem key="" value="">
                            Selecione...
                          </MenuItem>
                          {equips?.map(eq => (
                            <MenuItem key={eq.id} value={eq.id}>
                              {eq.name}
                            </MenuItem>
                          ))}
                        </TextField>
                      </Grid>

                      <Grid item xs={6}>
                        <KeyboardDatePicker
                          clearable
                          value={form.date_start}
                          label="Data Inicial"
                          fullWidth
                          margin="dense"
                          inputVariant="outlined"
                          views={['date']}
                          clearLabel="Limpar"
                          invalidDateMessage="Data inválida"
                          autoOk
                          onChange={date =>
                            setForm({ ...form, date_start: date })
                          }
                          format="dd/MM/yyyy"
                        />
                      </Grid>

                      <Grid item xs={6}>
                        <KeyboardDatePicker
                          clearable
                          value={form.date_end}
                          label="Data Final"
                          fullWidth
                          margin="dense"
                          inputVariant="outlined"
                          views={['date']}
                          clearLabel="Limpar"
                          invalidDateMessage="Data inválida"
                          autoOk
                          onChange={date =>
                            setForm({ ...form, date_end: date })
                          }
                          format="dd/MM/yyyy"
                        />
                      </Grid>

                      <Grid item xs={6}>
                        <SelectField
                          options={servicesTypes}
                          setForm={updateField}
                          data={form.service_type || null}
                          name="service_type"
                          margin="dense"
                          variant="outlined"
                          label="Tipo de Serviço"
                        />
                      </Grid>

                      <Grid item xs={6}>
                        <SelectField
                          options={companies}
                          setForm={updateField}
                          data={form.company || null}
                          name="company"
                          margin="dense"
                          variant="outlined"
                          label="Empresa"
                        />
                      </Grid>

                      <Grid item xs>
                        <Button
                          type="submit"
                          color="primary"
                          fullWidth
                          variant="contained"
                          className={classes.submit}
                          onClick={popupState.close}
                        >
                          <SearchIcon />
                          {` Filtrar`}
                        </Button>
                      </Grid>
                    </Grid>
                  </ValidatorForm>
                </div>
              </Box>
            </Popover>
          </div>
        )}
      </PopupState>
    </Tooltip>
  )
}
